<div class="row no-gutters col-12 d-flex align-items-center justify-content-end pr-0">
  <button class="btn btn-light" (click)="onConfirmClick()" [matTooltip]="'Close'">
    <i class="fa fa-close"></i>
  </button>
</div>
<div class="text-title text-center" *ngIf="!isModeEdit">Add Support Email</div>
<div class="text-title text-center" *ngIf="isModeEdit">Edit Support Email</div>
<form [formGroup]="supportEmailForm" class="row col-12 m-auto justify-content-center p-0">
  <div formArrayName="emails" class="col-12 justify-content-center pl-0 pr-0">
    <div *ngFor="let itemForm of supportEmailForm['controls'].emails['controls']; let idx=index"
      class="col-12 justify-content-between pl-0 pr-0">
      <div [formGroup]="itemForm" class="row col-12 justify-content-center no-gutters pl-0 pr-0">
        <div class="col-xl-6 col-md-6 col-sm-12 col-12 mt-3 justify-content-center">
          <div class="col-xl-11 col-md-11 col-sm-12 col-12 text-normal p-0">
            Name
          </div>
          <mat-form-field appearance="outline" style="margin-top: -8px;"
          class="col-xl-11 col-md-11 col-sm-12 col-12 justify-content-center text-normal p-0">
            <input formControlName="name" name="name" matInput #name placeholder="">
          </mat-form-field>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-12 col-12 mt-3 ml-auto">
          <div class="row col-xl-11 col-md-11 col-sm-12 col-12 text-normal no-gutters p-0 ml-auto">
            <div class="col-10">
              Email
            </div>
            <div class="col-2 text-right no-gutters">
              <mat-icon aria-label="attach file" (click)="removeEmail(idx)"
                [matTooltip]="'Remove'" style="cursor: pointer;">
                close
              </mat-icon>
            </div>
          </div>
          <div class="col-xl-11 col-md-11 col-sm-12 col-12 p-0 ml-auto"
          style="margin-top: -16px;">
            <mat-form-field appearance="outline"
            class="col-12 p-0 text-normal">
              <input formControlName="email" name="email" matInput #email placeholder="">
            </mat-form-field>
          </div>
        </div>
        <br>
      </div>
    </div>
    <div class="col-12 pl-0 text-right">
      <button type="button" class="btn btn-link" (click)="addItemSupportEmail()" *ngIf="supportEmailForm['controls'].emails['controls'].length < 10">
        Add another email
      </button>
    </div>
    <div class="row no-gutters col-12 d-flex align-items-center justify-content-center pt-4">
      <button class="btn btn-primary button col-xl-2 col-md-3 col-sm-6 text-normal"
      (click)="submitForm()">
      <span>
        SAVE
      </span>
    </button>
    </div>
  </div>
</form>